import React, { createContext, useContext, useEffect, useState } from 'react';
import { getCurrentSuperadmin, primeCsrf, superadminLogin, superadminLogout } from '../api/auth';

const SuperadminAuthContext = createContext(null);

export const SuperadminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await primeCsrf();
        const current = await getCurrentSuperadmin();
        if (!cancelled) setAdmin(current);
      } catch (err) {
        // Pas de session staff active — reste sur l'ecran de login superadmin.
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = async (username, password) => {
    const loggedInAdmin = await superadminLogin(username, password);
    setAdmin(loggedInAdmin);
    return loggedInAdmin;
  };

  const logout = async () => {
    // Best-effort : si la session etait deja expiree/invalide cote serveur (ex.
    // double-clic sur "Deconnexion", 2e appel apres que le 1er ait deja detruit
    // la session), l'etat vise ("plus authentifie") est de toute facon deja atteint
    // — on ne bloque jamais la navigation/le clear local pour ca.
    try {
      await superadminLogout();
    } catch (err) {
      // ignore
    }
    setAdmin(null);
  };

  return (
    <SuperadminAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </SuperadminAuthContext.Provider>
  );
};

export const useSuperadminAuth = () => {
  const ctx = useContext(SuperadminAuthContext);
  if (!ctx) throw new Error('useSuperadminAuth must be used within a SuperadminAuthProvider');
  return ctx;
};
